export default __webpack_public_path__ + "static/media/experience.47b6a143.svg";